import React from "react"

import Layout from "../components/layout/layout"
import Blog from "../components/blogs/Blogs"
import { graphql } from "gatsby"
import SEO from "../components/seo"

const OurBlogs = ({ data }) => (
  <Layout withBrand slidePosition={0}>
    <SEO
      title="Brand Analytics News & Brand Protection Tips - Wersel"
      description="Stay updated with brand analytics news, brand protection tips, technology news and much more through our wersel blog page."
      keywords="wersel, wersel blogs, wersel brand analytics, wersel brand analytics platform, wersel data hub"
      url="www.wersel.io/blogs"
    />
    <Blog
      posts={data.posts.edges}
      related_articles={data.related_articles.edges}
    />
  </Layout>
)
export const pageQuery = graphql`
  query BlogQuery {
    posts: allMarkdownRemark {
      edges {
        node {
          id
          frontmatter {
            title
            path
            date
            author
            description
            keywords
            category
            cover {
              childImageSharp {
                fluid {
                  originalImg
                }
              }
            }
            role
            slugImage {
              childImageSharp {
                fluid {
                  originalImg
                }
              }
            }
            authorImage {
              childImageSharp {
                fluid {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
        }
      }
    }
    related_articles: allMarkdownRemark {
      edges {
        node {
          id
          frontmatter {
            title
            path
            description
            cover {
              childImageSharp {
                fluid {
                  originalImg
                }
              }
            }
            role
          }
        }
      }
    }
  }
`
export default OurBlogs
